import Repository from "./Repository";

export default {
  // List Dealer RFQs
  getDealerRFQ(payload) {
    return Repository.get(`/dealer/RFQ`, {
      params: {
        page: payload ? payload.page : 1,
        size: payload ? payload.size : 10
        // status: (payload && payload.status) || "sent"
      }
    });
  },

  declineRFQ(payload) {
    return Repository.post(`/dealer/RFQ/${payload.id}/deny`, {
      message: payload.message
    });
  },

  getDealerRFQDetails(payload) {
    return Repository.get(`/dealer/RFQ/${payload.id}/schedule_item`);
  },

  getDealerContacts(payload) {
    return Repository.get(`RFQ/dealer_contacts`, { params: { ...payload } });
  },

  getProjectRFQs(payload) {
    return Repository.get(
      `RFQ/project/${payload.project_id}/schedule/${payload.schedule}`
    );
  },

  sendRFQ(payload) {
    return Repository.post(
      `RFQ/project/${payload.project_id}/schedule/${payload.schedule}`,
      {
        dealer_contact_email: payload.email,
        version_number: payload.version,
        expected_delievery_time: payload.expected_delievery_time
      }
    );
  },

  getDealerRFQById(payload) {
    return Repository.get(`dealer/RFQ/${payload.id}`);
  },

  acceptBid(payload) {
    return Repository.post(`/dealer/RFQ/${payload.id}/award`);
  },

  sendDealerQuote(payload) {
    const { id } = payload;
    delete payload.id;
    return Repository.post(`/dealer/RFQ/${id}/bid`, payload);
  }
};
